export const PageTitle = (title) => {
  return (document.title = title);
};
